import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const tutor = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    title: z.string().nullable().optional().describe('Title'),

    firstName: z.string().nullable().optional().describe('First Name'),

    lastName: z.string().nullable().optional().describe('Last Name'),

    email: z.string().nullable().optional().describe('Email'),

    inactive: z.boolean().nullable().optional().describe('Inactive'),

    appUserId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    appUser: references('User'),

    termTutors: hasMany('TermTutor'),
  })
  .describe('A volunteer or staff member who delivers tutoring sessions.')
  .as('Tutor');

export { tutor as tutorSchema };
